import { toSafeString } from './toSafeString.js';

export const toDisplayJson = (value) => {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return toSafeString(value) || 'null';
  }
};
